import api from './api';
import { User } from '../types';

export interface CreateUserData {
  name: string;
  email: string;
  dni: string;
  password: string;
  role: 'customer' | 'admin';
  role_id?: string;
}

export interface UpdateUserData {
  name: string;
  email: string;
  dni: string;
  role: 'customer' | 'admin';
  role_id?: string;
}

export const userService = {
  getUsers: async (): Promise<User[]> => {
    const response = await api.get('/users');
    return response.data.users || [];
  },
  
  getUser: async (id: string): Promise<User> => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },
  
  createUser: async (data: CreateUserData) => {
    const response = await api.post('/users', data);
    return response.data;
  },
  
  updateUser: async (id: string, data: UpdateUserData) => {
    const response = await api.put(`/users/${id}`, data);
    return response.data;
  },
  
  deleteUser: async (id: string) => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },
  
  resetPassword: async (id: string, newPassword: string) => {
    const response = await api.post(`/users/${id}/reset-password`, { newPassword });
    return response.data;
  }
};